import { useAuth } from "../../../../context";
import { useMutation, useQuery } from "react-query";
import { TreatmentOfSoldProducts } from "../../../../api";

export const treatmentOfSoldProductsKeys = {
  items: () => ["treatmentOfSoldProductsItems"]
};

export function useGetTreatmentOfSoldProductsItems(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...treatmentOfSoldProductsKeys.items(), params.queryParams.page, params.queryParams.size, params.queryParams.sort],
    () => callApi(TreatmentOfSoldProducts.getTreatmentOfSoldProductsItems, params), config);
}

export function useAddTreatmentOfSoldProductsItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(TreatmentOfSoldProducts.addTreatmentOfSoldProductsItems, { questionnaireId, data }), config);
}

export function useUpdateTreatmentOfSoldProductsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, data }) =>
    callApi(TreatmentOfSoldProducts.updateTreatmentOfSoldProductsItem, { questionnaireId, recordId, data }), config);
}

export function useDeleteTreatmentOfSoldProductsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId }) =>
    callApi(TreatmentOfSoldProducts.deleteTreatmentOfSoldProductsItem, { questionnaireId, recordId }), config);
}

export function useImportTreatmentOfSoldProductsItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(TreatmentOfSoldProducts.importTreatmentOfSoldProductsItems, { questionnaireId, data }), config);
}

export function useDownloadTreatmentOfSoldProductsTemplate(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId }) => callApi(TreatmentOfSoldProducts.getTemplate), config);
}